module.exports = __webpack_public_path__ + "static/media/greentube.602fafc0.svg";